const filterAnchorableBlocks = (array, filter) => {
  return array.filter((block) => block.anchorType === filter);
};

export { filterAnchorableBlocks };
//# sourceMappingURL=anchorUtils.js.map
